export default __webpack_public_path__ + "de2b17935a973676e5750a5a0dd498b2.png";